//Generated File 
export default class DecimalScaleStrategies{
	static readonly MONEY_CURRENCY = `money.currency`;
	static readonly NONE = `@none`;
	static readonly PERCENT = `@percent`;
	static readonly RATE = `@rate`;
	static readonly ROOT = `~`;
	static readonly ROOT_LOCAL_CURRENCY = `~localCurrency`;
	static readonly ROOT_MONEY_CURRENCY = `~money.currency`;
	static readonly VALUE_CURRENCY = `value.currency`;
}
